<template>
  <div>
    <v-container>
      <v-row>
        <v-col :cols="12">
          <v-text-field
            :label="'Product Name'"
            v-model="product.name"
          ></v-text-field>
        </v-col>

        <v-col :cols="12"
          ><v-text-field
            :label="'Product Price'"
            type="number"
            v-model="product.price"
          ></v-text-field
        ></v-col>
        <v-col :cols="12">
          <v-text-field
            :label="'Quantity'"
            v-model="product.quantity"
          ></v-text-field>
        </v-col>

        <v-col :cols="6"
          ><v-btn @click="regeneratePDF()" color="teal" dark
            ><v-icon>mdi-check</v-icon>Add Product</v-btn
          ></v-col
        >
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
export default {
  data: () => ({
    product: {
      name: null,
      cost: 0,
      price: 0,
      code: "PX-172-01",
      category_id: 0,
      serviceCategory: "General Product",
      list_on_store: "No",
      item_type: "product",
      quantity: 1,
      category: {
        id: 0,
        name: "General Product",
      },
      inventory: {
        amount_in_stock: "0",
        amount_received: "0",
        amount_sold: "0",
        id: 1,
        product_id: "0",
        quantity_in_stock: "9999999999999999",
        quantity_received: "9999999999999999",
        quantity_sold: "0",
      },
      imagePath: "/images/products/no-photo.jpg",
      link: "12121111211",
    },
  }),

  methods: {
    regeneratePDF() {
      if (!this.product.name) {
        alert("Product Name is Required!");
        return false;
      }
      this.product.price = this.stripNonDigitsAndCommasFromMoney(
        this.product.price
      );
      this.$emit("product-updated", this.product);
    },
    stripNonDigitsAndCommasFromMoney(amount) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(amount);
    },
  },
};
</script>

<style></style>
